import styled from "styled-components";
import { ExternalLink } from "../../links/ExternalLink";
import { colors } from "../../../styles/variables";

export const StyledEmailOptIn = styled.div`
  width: 100%;
  font-size: 13px;
  margin-left: 5px;
  color: ${colors.gray600};
`;

export const StyledExternalLink = styled(ExternalLink)`
  color: ${({ theme }) => theme.color.primary};
`;
